"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Aggregate = void 0;
var _info = require("../../../common/config/info");
var _init = require("../../../common/config/init");
var _runtime = require("../../../common/config/runtime");
var _handle = require("../../../common/event-emitter/handle");
var _registerHandler = require("../../../common/event-emitter/register-handler");
var _harvestScheduler = require("../../../common/harvest/harvest-scheduler");
var _console = require("../../../common/util/console");
var _stringify = require("../../../common/util/stringify");
var _constants = require("../../metrics/constants");
var _aggregateBase = require("../../utils/aggregate-base");
var _constants2 = require("../constants");
var _log = require("../shared/log");
var _utils = require("../shared/utils");
var _traverse = require("../../../common/util/traverse");
var _agentConstants = require("../../../common/constants/agent-constants");
var _eventBuffer = require("../../utils/event-buffer");
class Aggregate extends _aggregateBase.AggregateBase {
  static featureName = _constants2.FEATURE_NAME;
  #agentRuntime;
  #agentInfo;
  constructor(agentIdentifier, aggregator) {
    super(agentIdentifier, aggregator, _constants2.FEATURE_NAME);

    /** held logs before sending */
    this.bufferedLogs = new _eventBuffer.EventBuffer();
    this.#agentRuntime = (0, _runtime.getRuntime)(this.agentIdentifier);
    this.#agentInfo = (0, _info.getInfo)(this.agentIdentifier);
    this.harvestTimeSeconds = (0, _init.getConfigurationValue)(this.agentIdentifier, 'logging.harvestTimeSeconds');
    this.waitForFlags([]).then(() => {
      this.scheduler = new _harvestScheduler.HarvestScheduler('browser/logs', {
        onFinished: this.onHarvestFinished.bind(this),
        retryDelay: this.harvestTimeSeconds,
        getPayload: this.prepareHarvest.bind(this),
        raw: true
      }, this);
      /** emitted by instrument class (wrapped loggers) or the api methods directly */
      (0, _registerHandler.registerHandler)(_constants2.LOGGING_EVENT_EMITTER_CHANNEL, this.handleLog.bind(this), this.featureName, this.ee);
      this.drain();
      /** harvest immediately once started to purge pre-load logs collected */
      this.scheduler.startTimer(this.harvestTimeSeconds, 0);
    });
  }
  handleLog(timestamp, message, attributes = {}, level = _constants2.LOG_LEVELS.INFO) {
    if (this.blocked) return;
    if (!attributes || typeof attributes !== 'object') attributes = {};
    if (typeof level === 'string') level = level.toUpperCase();
    if (!(0, _utils.isValidLogLevel)(level)) return (0, _console.warn)(30, level);
    try {
      if (typeof message !== 'string') {
        const stringified = (0, _stringify.stringify)(message);
        /**
           * Error instances convert to `{}` when stringified
           * Symbol converts to '' when stringified
           * other cases tbd
           * */
        if (!!stringified && stringified !== '{}') message = stringified;else message = String(message);
      }
    } catch (err) {
      (0, _console.warn)(16, message);
      return;
    }
    if (typeof message !== 'string' || !message) return (0, _console.warn)(32);
    const log = new _log.Log(Math.floor(this.#agentRuntime.timeKeeper.correctAbsoluteTimestamp(this.#agentRuntime.timeKeeper.convertRelativeTimestamp(timestamp))), message, attributes, level);
    const logBytes = log.message.length + (0, _stringify.stringify)(log.attributes).length + log.level.length + 10; // timestamp == 10 chars

    if (!this.bufferedLogs.canMerge(logBytes)) {
      if (this.bufferedLogs.hasData) {
        (0, _handle.handle)(_constants.SUPPORTABILITY_METRIC_CHANNEL, ['Logging/Harvest/Early/Seen', this.bufferedLogs.bytes + logBytes]);
        this.scheduler.runHarvest({});
        if (logBytes < _agentConstants.MAX_PAYLOAD_SIZE) this.bufferedLogs.add(log);
      } else {
        (0, _handle.handle)(_constants.SUPPORTABILITY_METRIC_CHANNEL, ['Logging/Harvest/Failed/Seen', logBytes]);
        (0, _console.warn)(31, log.message.slice(0, 25) + '...');
      }
      return;
    }
    this.bufferedLogs.add(log);
  }
  prepareHarvest(options = {}) {
    if (this.blocked || !this.bufferedLogs.hasData) return;
    /** see https://source.datanerd.us/agents/rum-specs/blob/main/browser/Log for logging spec */
    const payload = {
      qs: {
        browser_monitoring_key: this.#agentInfo.licenseKey
      },
      body: [{
        common: {
          /** Attributes in the `common` section are added to `all` logs generated in the payload */
          attributes: {
            'entity.guid': this.#agentRuntime.appMetadata?.agents?.[0]?.entityGuid,
            // browser entity guid as provided from RUM response
            session: this.#agentRuntime?.session?.state.value || '0',
            // The session ID that we generate and keep across page loads
            hasReplay: this.#agentRuntime?.session?.state.sessionReplayMode === 1,
            // True if a session replay recording is running
            hasTrace: this.#agentRuntime?.session?.state.sessionTraceMode === 1,
            // True if a session trace recording is running
            ptid: this.#agentRuntime.ptid,
            // page trace id
            appId: this.#agentInfo.applicationID,
            // Application ID from info object,
            standalone: Boolean(this.#agentInfo.sa),
            // copy paste (true) vs APM (false)
            agentVersion: this.#agentRuntime.version // browser agent version
          }
        },
        /** logs section contains individual unique log entries */
        logs: (0, _traverse.applyFnToProps)(this.bufferedLogs.buffer, this.obfuscator.obfuscateString.bind(this.obfuscator), 'string')
      }]
    };
    if (options.retry) this.bufferedLogs.hold();else this.bufferedLogs.clear();
    return payload;
  }
  onHarvestFinished(result) {
    if (result.retry) this.bufferedLogs.unhold();else this.bufferedLogs.held.clear();
  }
}
exports.Aggregate = Aggregate;